import React from 'react';
import { default as isFavouritePage } from "@pb/utils/isFavouritePage";
import cn from 'classnames';
import { CTALink } from "../../../../../../ui/CTA";
import { EmailIcon, BellIcon } from "../../../../../../ui/Icon";
import BodyText from "../../../../../../ui/Typography/texts/BodyText";
import MetaText from "../../../../../../ui/Typography/texts/MetaText";
import styles from './DropdownElement.module.scss';
const DropdownElement = ({ className, data, value, valueInfo, onClickChangeItemVariant, nibOnClick, shouldNIB, isOOS, variantCode, isVariantSelected, isDisabled, isDropDownItemsCenterAligned = false, notifyIfBackIcon = 'email', nibIconSize = 'small', }) => {
    if (!value) {
        return null;
    }
    const url = window.location.href;
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            onClickChangeItemVariant(data);
        }
    };
    const handleNibKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (nibOnClick) {
                nibOnClick();
            }
        }
    };
    return (React.createElement("li", Object.assign({ id: variantCode }, (isFavouritePage(url) ? {} : { role: 'option', 'aria-selected': isVariantSelected })),
        React.createElement("div", { className: cn(styles.container, className) },
            React.createElement("button", { tabIndex: 0, "aria-label": value, type: "button", onClick: () => onClickChangeItemVariant(data), onKeyDown: handleKeyDown, disabled: isDisabled, className: cn(styles.buttonContainer, isDropDownItemsCenterAligned && styles.buttonCenterAlign) },
                React.createElement(BodyText, { Tag: "span", className: cn(styles.value, isDropDownItemsCenterAligned && styles.valueCenterAlign) }, value),
                valueInfo && !shouldNIB && (React.createElement(MetaText, { className: cn(styles.valueInfo, isOOS && styles.oos, isDropDownItemsCenterAligned && styles.valueInfoCenterAlign) }, valueInfo))),
            valueInfo && shouldNIB && (React.createElement(CTALink, { Tag: "button", className: styles.nibButton, onClick: nibOnClick, onKeyDown: handleNibKeyDown, iconElement: notifyIfBackIcon === 'bell' ? (React.createElement(BellIcon, { size: nibIconSize })) : (React.createElement(EmailIcon, { size: "small" })), iconPosition: "start" }, valueInfo)))));
};
export default DropdownElement;
//# sourceMappingURL=DropdownElement.js.map